export default "__VITE_ASSET__672480a6__"